<template>
  <section>
    <a href="#" @click.prevent="toggleDescontos()" v-if="!auto" class="btn btn-primary btnDesconto">
      <span>Descontos</span>&nbsp;
      <fa :icon="['fas','badge-percent']" />
    </a>
    <section-header :current="current" />
    <desconto-matricula v-if="matricula" :active="descontoActive" @close="descontoActive = false" @save="refreshPlanos" :idMatricula="matricula.matricula.idMatricula" />
    <planos-pagamento :current="current" :auto="auto" ref="planos"/>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import PlanosPagamento from '@/components/matriculas/4/form/PlanosPagamento.vue'
import DescontoMatricula from '@/components/matriculas/form/DescontoMatricula'
export default {
  components: {
    SectionHeader, PlanosPagamento, DescontoMatricula
  },
  props: {
    current: Object,
    auto: Boolean
  },
  data () {
    return {
      descontoActive: false,
      matricula: null
    }
  },
  mounted () {
    this.$store.dispatch('matricula/get').then(response => {
      this.matricula = response
    })
  },
  methods: {
    toggleDescontos () {
      this.descontoActive = !this.descontoActive
    },
    refreshPlanos () {
      this.$refs.planos.forceGetPlanos()
    }
  }
}
</script>

<style lang="scss" scoped>
  .btnDesconto {
    position: absolute;
    top: $mg; right: $mg
  }
</style>